import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { MEASUREMENT_TYPE } from "tagTypes";

export const useMeasurementTypeQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/measurement-type",
    query,
    tags: [MEASUREMENT_TYPE],
  });

export const useLazyMeasurementTypeQuery = () => {
  const [getMeasurementType, data] = useLazyGetQuery();
  const measurementType = async (query = {}) =>
    await getMeasurementType(
      {
        endpoint: "/measurement-type",
        query,
        tags: [MEASUREMENT_TYPE],
      },
      true
    ).unwrap();
  return [measurementType, data];
};

export const usePostMeasurementTypeMutation = () => {
  const [postMeasurementType, data] = usePostMutation();
  const measurementType = async (payload, query = {}) =>
    await postMeasurementType({
      endpoint: "/measurement-type",
      query,
      payload: payload || {},
      toastMessage: "Measurement type added successfully",
      tags: [MEASUREMENT_TYPE],
    }).unwrap();
  return [measurementType, data];
};
